import 'classlist-polyfill'
import 'promise-polyfill/src/polyfill'

import React, { FC, useState, useEffect } from 'react'
import Chart from "react-apexcharts"
import { useTranslation } from 'react-i18next'

import { chartOptions as initialChartOptions } from './VariablesApplicationHeatMap'
import Loading from '../common/Loading'

import { MemberReportHeatMap } from '../../../states/types/member'
import { uniqueId } from 'lodash'
import InfoTips from '../common/InfoTips'

interface ApplicationWorkValueProps {
  isLoading: boolean | undefined
  heatMap: MemberReportHeatMap | undefined
}

const ApplicationWorkValue: FC<ApplicationWorkValueProps> = (props) => {
  const { t } = useTranslation()

  const {
    isLoading,
    heatMap,
  } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [chartData, setChartData] = useState<any>(undefined)

  useEffect(() => {
    if (!heatMap) {
      setChartData(undefined)
      return
    }

    const chartOptions = initialChartOptions
    chartOptions.xaxis.categories = heatMap.label.days
    chartOptions.xaxis.labels.style.colors = heatMap.label.color
    chartOptions.colors = [...heatMap.color]

    setChartData({
      series: [...heatMap.data],
      option: {
        ...chartOptions,
        xaxis: {
          ...chartOptions.xaxis,
        },
        tooltip: {
          ...chartOptions.tooltip,
        },
      },
      height: 35 * heatMap.data.length + 100,
    })
  }, [heatMap])

  return (
    <div style={{ marginLeft: "0.5em", marginRight: "0.5em" }}>
      <div className="box member-heatmap">
        <div style={{ paddingTop: "1em", textAlign: "center" }}>
          <span style={{ fontSize: "24px", fontWeight: "bold", color: "#094E8D" }}>{t("parts.application_work_value.title")}</span>
        </div>
        <InfoTips>
          <>
            <div>
              各アプリケーションの使用状況を濃淡で示す「ヒートマップ」で表示しています
            </div>
          </>
        </InfoTips>
        <div
          style={{
            position: "relative",
          }}
        >
          {
            (isLoading || !chartData || !heatMap) ? (
              <Loading />
            ) : (
              <>
                <div className={`heatmap-icons ${chartData.option.xaxis.categories.length > 11 && "mini"}`}>
                  {
                    heatMap?.data.map((item) => (
                      <React.Fragment key={uniqueId()}>
                        <div className="icon" style={{ background: item.background_color }}>
                          <i className={item.icon} style={{ color: item.icon_color }} />
                        </div>
                      </React.Fragment>
                    ))
                  }
                </div>
                <div className="box-body heatmap-body">
                  <div>
                    <Chart
                      options={chartData.option}
                      type="heatmap"
                      series={chartData.series}
                      height={`${chartData.height}px`}
                    />
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default ApplicationWorkValue
